// tslint:disable: max-line-length
import { AccountData } from './account-data';
import { BusinessData } from './business-data';
import { DepositAccountData } from './deposit-account-data';
import { PhoneVerification } from './phone-verification';
import { isEmpty } from '../utils/validations';

export class UserCompletedData {
    public phoneVerification: PhoneVerification;
    public businessData: BusinessData;
    public accountData: AccountData;
    public depositAccountData: DepositAccountData;

    constructor(object?: any) {
        object = object ? object : {};
        this.phoneVerification = isEmpty(object.phoneVerification) ? new PhoneVerification() : new PhoneVerification(object.phoneVerification);
        this.businessData = isEmpty(object.businessData) ? new BusinessData() : new BusinessData(object.businessData);
        this.accountData = isEmpty(object.accountData) ? new AccountData() : new AccountData(object.accountData);
        this.depositAccountData = isEmpty(object.depositAccountData) ? new DepositAccountData() : new DepositAccountData(object.depositAccountData);
    }

    get requiredStepsCompleted(): boolean {
        return this.phoneVerification.completed
        && this.businessData.completed
        && this.depositAccountData.completed;
    }
}
